import React from 'react';
import { Typography } from 'fronton-react';

import { modalShopItem, modalShopItemLabel, modalShopItemStock } from './styles';

export type ModalShopItemProps = {
  storeName: string;
  stockUnit: string;
  stockValue: number;
  address?: string;
};

export const ModalStoreItem: React.FC<ModalShopItemProps> = ({
  storeName,
  stockValue,
  stockUnit,
  address,
}) => {
  const inStockText = stockValue ? `В наличии ${stockValue} ${stockUnit}` : 'Нет в наличии';
  return (
    <div className={modalShopItem}>
      <div className={modalShopItemLabel}>
        <Typography size="body_accent" variant="s" color="text-primary">
          {storeName}
        </Typography>
      </div>
      {address && (
        <Typography data-qa="modal-store-item-address" variant="caption" color="text-secondary">
          {address}
        </Typography>
      )}
      <Typography
        className={modalShopItemStock}
        color={stockValue ? 'success-primary' : 'secondary-orange-primary'}
        variant="caption_accent"
        data-qa="modal-store-item-in-stock-text"
      >
        {inStockText}
      </Typography>
    </div>
  );
};
